import {
	ChangeDetectionStrategy,
	Component,
	Inject,
	OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FolderChildren } from '@core/util/folder';
import { DocumentV2, GlobalWordDocumentTemplate } from '@models/documents';
import { DefaultFolder, Folder } from '@models/matter';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select } from '@ngxs/store';
import { BusinessFoldersState } from '@state/business/folders/folders.state';
import { Observable } from 'rxjs/internal/Observable';

export interface TemplateMoveDialogData {
	document: DocumentV2 | GlobalWordDocumentTemplate;
}

export type TemplateMoveDialogClose = string | null;

interface MoveDocumentFolder extends Folder {
	children: number;
}

const DefaultMoveDocumentFolder: MoveDocumentFolder = {
	...DefaultFolder,
	children: 0,
};

@UntilDestroy()
@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'app-move-document-dialog',
	templateUrl: 'template-move-dialog.component.html',
	standalone: false,
})
export class TemplateMoveDialogComponent implements OnInit {
	currentFolderId: string;
	oldFolderId: string;
	folders: MoveDocumentFolder[];
	@Select(BusinessFoldersState.getAll) folders$: Observable<Folder[]>;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: TemplateMoveDialogData,
		private dialogRef: MatDialogRef<TemplateMoveDialogComponent>,
	) {}

	ngOnInit(): void {
		this.currentFolderId = '';
		this.folders$.pipe(untilDestroyed(this)).subscribe((folders) => {
			this.folders = folders.map((folder) => ({
				...DefaultMoveDocumentFolder,
				...folder,
				children: FolderChildren(folder.id, folders).length,
			}));
			this.folders.sort((prev, curr) => (prev.title < curr.title ? -1 : 1));
			this.currentFolderId =
				this.folders.find((folder) => folder.id === this.data.document.folderId)
					?.id ||
				this.data.document.folderId ||
				'';
			this.oldFolderId = this.currentFolderId;
		});
	}

	cancelModal(): void {
		this.dialogRef.close(null);
	}

	moveDocument(): void {
		const data: TemplateMoveDialogClose = this.currentFolderId || '';
		this.dialogRef.close(data);
	}
}
